import { useBrandsSearchQuery } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/__internal__/useBrandsSearchQuery";
import { ISearchBrandsV2Response } from "@faire/web-api--source/indigofair/data/ISearchBrandsV2Response";

export const useLoggedOutSuppliersPageBrandSearchResults = ():
  | ISearchBrandsV2Response.IBrand[]
  | undefined => {
  return useBrandsSearchQuery().data?.brandSearchResults;
};
